import { useLocalStorageState } from 'ahooks';
import { useEffect, useState } from 'react';
import { regionLanguageMap } from 'services/config/region';
import toLowerCase from 'utils/toLowerCase';

export const regionTransLangMap: Record<General.Region, General.Language> = {
  ...regionLanguageMap,
  ph: 'tl',
};

export const useTargetLang = (region?: General.UpperCaseRegion, sync = true) => {
  const [localStorageTargetLang, setLocalStorageTargetLang] =
    useLocalStorageState<General.Language>('translateToolTargetLang');
  const [targetLang, setTargetLang] = useState<General.Language>(() =>
    region && regionTransLangMap[toLowerCase(region)]
      ? regionTransLangMap[toLowerCase(region)]
      : localStorageTargetLang || 'en-US',
  );

  useEffect(() => {
    if (sync) {
      setLocalStorageTargetLang(targetLang);
    }
  }, [targetLang, setLocalStorageTargetLang, sync]);

  return {
    targetLang,
    setTargetLang,
  };
};
